<template>
    <v-menu location="bottom end">
        <template #activator="{ props: menuProps }">
            <v-btn
                v-bind="menuProps"
                icon="mdi-dots-vertical"
                size="small"
                variant="text"
                :aria-label="$t('admin.offerPresets.actions.forPreset', { name: preset.name })"
            />
        </template>
        <v-list class="offer-presets-actions" density="compact" nav>
            <v-list-item
                v-for="action in actions"
                :key="action.id"
                class="offer-presets-actions__item"
                :class="{ 'offer-presets-actions__item--danger': action.danger }"
                :prepend-icon="action.icon"
                :title="toSentenceCase($t(action.labelKey))"
                @click="action.handler(preset)"
            />
        </v-list>
    </v-menu>
</template>

<script setup>
import { computed } from 'vue';
import { toSentenceCase } from '@/js/utils/string-utils';

const props = defineProps({ params: { type: Object, required: true } });
const preset = computed(() => props.params.data);
const actions = computed(() =>
    [
        {
            id: 'preview',
            icon: 'mdi-eye-outline',
            labelKey: 'admin.offerPresets.actions.previewTag',
            handler: props.params.onPreview,
        },
        {
            id: 'edit',
            icon: 'mdi-pencil-outline',
            labelKey: 'admin.offerPresets.actions.edit',
            handler: props.params.onEdit,
        },
        {
            id: 'duplicate',
            icon: 'mdi-content-copy',
            labelKey: 'admin.offerPresets.actions.duplicate',
            handler: props.params.onDuplicate,
        },
        preset.value.source === 'system' &&
            preset.value.isModified && {
                id: 'reset',
                icon: 'mdi-restore',
                labelKey: 'admin.offerPresets.actions.reset',
                handler: props.params.onReset,
            },
        {
            id: 'delete',
            icon: 'mdi-delete-outline',
            labelKey: 'admin.offerPresets.actions.delete',
            handler: props.params.onDelete,
            danger: true,
        },
    ].filter(Boolean)
);
</script>

<style scoped lang="scss">
.offer-presets-actions {
    min-width: 22rem;
    padding: 0.4rem !important;

    &__item {
        min-height: 4.2rem !important;
        padding: 0 1.4rem !important;
        border-radius: 0.4rem;

        :deep(.v-list-item-title) {
            font-size: 1.6rem;
            line-height: 2.4rem;
            letter-spacing: normal;
        }

        :deep(.v-list-item__prepend) {
            .v-icon {
                font-size: 2rem;
                opacity: 0.7;
            }

            .v-list-item__spacer {
                width: 1.4rem;
            }
        }

        &--danger {
            margin-top: 0.4rem;
            border-top: 1px solid #dfe3e8;
            border-radius: 0 0 0.4rem 0.4rem;
            color: #c62828;

            :deep(.v-icon) {
                color: #c62828;
                opacity: 1;
            }
        }
    }
}
</style>
